import { ChevronDown, ChevronUp } from 'react-bootstrap-icons';
import React, { useEffect, useState } from 'react';
import { FilterOptionValue, MappedFacet } from '@mybestbrands/types';
import styles from './filters.module.scss';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';

export function ShopsFilter({
  filter,
  isActive,
  toggleFilterOptions,
  onFilterUpdate,
  onApplySearchFilters,
}: {
  filter: FilterOptionValue | undefined;
  isActive: boolean;
  onApplySearchFilters: () => void;
  onFilterUpdate: (value: string[]) => void;
  toggleFilterOptions: () => void;
}) {
  const { t } = useTranslation('filters');
  const [filterOptions, setFilterOptions] = useState([] as MappedFacet[]);
  const [selectedShops, setSelectedShops] = useState([] as string[]);

  useEffect(() => {
    if (!filter || !filter?.options?.length) return;

    const selectedShops = filter.options.filter((option) => option.checked).map((option) => option.value);
    setFilterOptions(filter.options);
    setSelectedShops(selectedShops);
  }, [filter?.options]);

  const Chevron = isActive ? ChevronUp : ChevronDown;

  if (!filter || !filter?.options?.length) return null;

  function onShopSelect(id: string) {
    if (selectedShops.includes(id)) {
      const newSelectedShop = selectedShops.filter((shop) => shop !== id);
      setSelectedShops(newSelectedShop);
      onFilterUpdate(newSelectedShop);
    } else {
      setSelectedShops([...selectedShops, id]);
      onFilterUpdate([...selectedShops, id]);
    }
  }

  function onSearchInputChange(e: React.ChangeEvent<HTMLInputElement>) {
    const value = e.target.value.toLowerCase();

    const newFilterOptions = (filter?.options || []).filter((option) => {
      return option.name.toLowerCase().includes(value);
    });

    if (newFilterOptions) setFilterOptions(newFilterOptions);
  }

  return (
    <div
      key={filter.name}
      className={clsx(styles.filterDefaultZIndex, 'position-relative')}
      style={{
        zIndex: 2,
      }}>
      <div
        onClick={toggleFilterOptions}
        key={filter.name}
        className={`btn btn-white-hover-black lowercase d-flex justify-content-center align-items-center ${styles.filter}`}>
        <span className="me-1">{t(filter.name)}</span>
        {!!selectedShops.length && (
          <span className={`${styles.filtercounter}`}>
            <span className="position-relative" style={{ bottom: '1px' }}>
              {selectedShops.length}
            </span>
          </span>
        )}
        <Chevron className="ms-2" />
      </div>
      {isActive && (
        <div className={`position-absolute bg-white border border-dark p-2 filter-list`} style={{ top: '35px' }}>
          <div className={`d-flex flex-wrap ${styles.shopsContainer}`} style={{ gap: '0.3rem', paddingBottom: 1 }}>
            <div className="input-group d-inline-flex align-items-end w-100">
              <input
                type="search"
                onChange={onSearchInputChange}
                className={`form-control border-grey w-100 px-2 mb-2 ${styles.shopSearchInput}`}
                placeholder={t('SEARCH_RETAILERS')}
                autoCorrect="off"
              />
            </div>
            {filterOptions.map((option) => (
              <div
                onClick={() => onShopSelect(option.id)}
                key={option.id}
                className="d-flex align-items-center mb-2 w-100"
                style={{ fontSize: '0.775rem' }}>
                <input
                  className="cursor-pointer"
                  name="shops"
                  type="checkbox"
                  checked={selectedShops.includes(option.id)}
                  onChange={() => {}}
                  style={{ display: 'initial', accentColor: 'transparent' }}
                />
                <label className={clsx(`ms-2 cursor-pointer me-3`, styles.shopOption, option.checked ? 'fw-bold' : '')}>
                  <span className={'me-2'}>{option.name}</span>
                  <span className={styles['filter-badge-gray']}>{option.count}</span>
                </label>
              </div>
            ))}
          </div>
          <div className="position-relative">
            <button
              onClick={onApplySearchFilters}
              className="btn filter btn-white-hover-black lowercase mt-3 mb-2 w-100">
              {t('SAVE')}
              <span className="ms-1" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
